import type { IOnboardingStepText } from '../../types/IOnboardingStepText'

export const settingsTexts: Record<string, IOnboardingStepText> = {
  'settings.intro': {
    title: 'Настройки портала',
    text: 'Сведения об организации, её структура, оформление отчётов и интеграции. Разделы переключаются кнопками справа вверху, их набор зависит от ваших прав.',
  },
  'settings.noOrganization': {
    title: 'Реквизиты организации',
    text: 'Реквизиты и документы, от которых зависят «Обращения граждан», заполняет сотрудник с правом на настройки организации.',
  },
  'settings.tabs.organization': {
    title: 'Организация',
    text: 'Реквизиты, контакты, логотип и документы для «Обращений граждан».',
  },
  'settings.requisites': {
    title: 'Реквизиты для согласия',
    text: 'Полное наименование, ИНН, ОГРН и юридический адрес попадают в согласие на обработку персональных данных. Без них «Обращения граждан» не включатся.',
  },
  'settings.email': {
    title: 'Электронная почта',
    text: 'Тоже нужна для согласия: по ней пациент может отозвать согласие.',
  },
  'settings.documents': {
    title: 'Документы',
    text: '«Обращения граждан» работают, когда оба документа готовы и синхронизированы с личным кабинетом пациента.',
  },
  'settings.consent': {
    title: 'Согласие на обработку ПД',
    text: 'Портал формирует его сам после сохранения реквизитов и обновляет при каждом их изменении. Загружать ничего не нужно.',
  },
  'settings.agreement': {
    title: 'Соглашение об обработке ПД',
    text: 'PDF-документ вашей организации — прикрепите кнопкой или вставьте из буфера. Если его удалить, «Обращения граждан» заблокируются.',
  },
  'settings.save': {
    title: 'Сохранить',
    text: 'Сохраняет реквизиты и контакты. Соглашение сохраняется сразу при прикреплении.',
  },
  'settings.importNorms': {
    title: 'Импорт нормативных документов',
    text: 'Загрузка нормативной базы из файла и история прошлых загрузок.',
  },
  'settings.tabs.structure': {
    title: 'Структура больницы',
    text: 'Подразделения и помещения организации — их выбирают в формах всех модулей.',
  },
  'settings.importLocations': {
    title: 'Импорт помещений',
    text: 'Загрузка списка помещений из файла вместо ручного ввода и история прошлых загрузок.',
  },
  'settings.tabs.branding': {
    title: 'Фирменное оформление',
    text: 'Логотип и оформление печатных форм и отчётов.',
  },
  'settings.tabs.integrations': {
    title: 'Интеграции',
    text: 'Вебхуки: портал отправляет события во внешние системы организации.',
  },
}
